export default {
  data: {
    name: 'Name',
    phone: 'Telephone',
    fax: 'Fax',
    email: 'Email',
    department: 'Department',
    departmentCode: 'Department Code',
    assignedAccountId: 'Accounting Account Code',
    assignedAccountIdTooltip: 'Enter your accounting software partner code here'
  },
  mandatory: {
    email: 'If receiver isnt registered, platform will send an email'
  },
  options: {
    faceB2b: 'DIRe (FACeB2B)',
    faceDir3: 'DIR3 (FACe)',
    noFace: 'Nothing'
  },
  additionalInfo: {
    code: 'Code',
    description: 'Description',
    postalCode: 'Post code',
    address: 'Address',
    street: 'Address',
    city: 'State',
    town: 'City',
    country: 'Country',
    name: 'Name',
    firstname: 'Firstname',
    lastname: 'Lastname'
  }
}
